/* @flow */

import * as React from 'react';
import styled from 'styled-components';

const PositionY = {
  'cny': 0,
  'eur': '-29px',
  'gbp': '-58px',
  'jpy': '-87px',
  'krw': '-116px',
  'rub': '-145px',
  'usd': '-174px',
  'cad': '-203px',
  'idr': '-232px',
  'aud': '-261px',
  'inr': '-290px',
  'try': '-319px',
  'brl': '-348px',
};

const Iconfont = styled.i`
  display: inline-block;
  width: 24px;
  height: 24px;
  vertical-align: middle;
  background-image: url(${require('./currency.png')});
  background-size: 100% auto;
  background-position-x: 0;;
  background-position-y: ${({ type }) => type ? `${PositionY[type]}` : 0};
`;

export type Props = {
  type: string,
};

const Icon = ({
  type, ...others
}: Props) => (
  <Iconfont type={type} {...others} />
);

Icon.defaultProps = {
  type: '',
};

export default Icon;
